<page-top *ngIf="storeService.auth"></page-top>
<sidebar *ngIf="storeService.auth"></sidebar>

<main class="o-p"
      [class.page-top--active]="storeService.auth"
      [class.sidebar--active]="storeService.sidebar" (click)="hideSidebar()">
  <breadcrumbs class="d-block mb-1"></breadcrumbs>
  <router-outlet></router-outlet>
</main>

